<template>
  <div class="category">
    <!-- <div v-for="(item, index) in selectCategoryList" :key="item.id" class="back ellipsis pointer" @click="back(index)">
      <i class="iconfont icon-a-arrow-left-s-line2"></i>
      {{item.name}}
    </div> -->
    <div v-for="(item) in currentCategoryList" :key="item.id" class="current-category ellipsis pointer" @click="selectCategory(item)">
      <span class="item-name ellipsis2" v-if="item.categoryId === selectCategoryId">
          <h4 style="color:#99c41c;">{{ item.name }}</h4>
      </span>
      <span class="item-name ellipsis2" v-else>
        {{ item.name }}
      </span>
    </div>
  </div>
</template>

<script>
import { depthTraversal } from '@/util/tree.js'
export default {
  data() {
    return {
      selectCategoryList: [],
      currentCategoryList: [],
      selectCategoryId: undefined

    }
  },
  computed: {
    categoryTree() {
      return this.$store.state.common.categoryTree
    }
  },
  created() {
    if (this.categoryTree.length > 0) {
      this.currentCategoryList = this.categoryTree
    } else {
      this.$store.dispatch('common/getCategoryTree').then(() => {
        this.currentCategoryList = this.categoryTree
      })
    }
  },
  methods: {
    selectCategory(category) {
      this.currentCategoryList = category.childList || []
      const isAlreadySelected = this.selectCategoryList.some((selectedCategory) => {
        return selectedCategory.id === category.id
      })
      if (!isAlreadySelected) {
        this.selectCategoryList.push(category)
      } else {
        this.selectCategoryList.push(null)
      }
      if (category.childList && category.childList.length > 0) {
        this.currentCategoryList = category.childList
      } else {
        const existingIndex = this.selectCategoryList.findIndex((selectedCategory) => {
          return selectedCategory.level === category.level
        })
        if (existingIndex) {
          // 如果找到相同级别的类别，替换它
          this.selectCategoryList.splice(existingIndex, this.selectCategoryList.length, category)
        }
        // 查找父类别（基于“parentId”）
        const parentId = category.parentId
        if (parentId) {
          // 查找父级的同级类别
          const parentCategory = this.selectCategoryList.find(item => item.categoryId === parentId)
          if (parentCategory) {
            this.currentCategoryList = parentCategory.childList
          }
        } else {
          // 如果没有父级（或未找到parentId），则显示顶级类别
          this.currentCategoryList = this.categoryTree
        }
      }
      this.change()
      this.setSelectCategoryId()
      this.$emit('selectCategory', this.selectCategoryList)
    },
    back(index) {
      this.currentCategoryList = this.categoryTree
      if (index > 0) {
        const category = this.selectCategoryList[index - 1]
        if (category.childList && category.childList.length > 0) {
          this.currentCategoryList = this.selectCategoryList[index - 1].childList
        } else {
          const parentId = category.parentId
          if (parentId) {
          // 查找父级的同级类别
            const parentCategory = this.selectCategoryList.find(item => item.categoryId === parentId)
            this.currentCategoryList = parentCategory.childList
          }
        }
      }
      this.selectCategoryList.splice(index, this.selectCategoryList.length)
      this.change()
      this.setSelectCategoryId()
    },
    change() {
      const category = this.selectCategoryList[this.selectCategoryList.length - 1]
      category ? this.$emit('change', category.categoryId, category) : this.$emit('change')
      if (category && category.categoryUrl) {
        location.href = '/product-list/' + category.categoryUrl
      }
      this.setSelectCategoryId()
    },
    reset() {
      this.selectCategoryList = []
      this.currentCategoryList = this.categoryTree
    },

    setSelectCategoryId() {
      if (this.selectCategoryList) {
        this.selectCategoryId = this.selectCategoryList[this.selectCategoryList.length - 1].categoryId
      }
    },
    setDefaultCategory(categoryId) {
      if (!categoryId) return null
      let selectCategoryList = []
      depthTraversal(this.categoryTree, (item, level) => {
        if (level === 0) selectCategoryList = []
        selectCategoryList[level] = item
        if (+item.categoryId === +categoryId) {
          selectCategoryList.length = level + 1
          return false
        }
      }, 'childList')
      if (selectCategoryList.length === 0) return null
      console.log('depthTraversalselectCategoryList', selectCategoryList)
      this.selectCategoryList = selectCategoryList
      this.$emit('selectCategory', this.selectCategoryList)
      const selectCategory = selectCategoryList[selectCategoryList.length - 1]
      this.currentCategoryList = []
      if (selectCategory.childList && selectCategory.childList.length > 0) {
        this.currentCategoryList = this.selectCategoryList[selectCategoryList.length - 1].childList
      } else {
        const parentId = selectCategory.parentId
        if (parentId) {
          // 查找父级的同级类别
          const parentCategory = this.selectCategoryList.find(item => item.categoryId === parentId)
          this.currentCategoryList = parentCategory.childList
        }
      }
      this.setSelectCategoryId()

      return selectCategoryList[selectCategoryList.length - 1]
    }
  }
}
</script>

<style lang="scss" scoped>
.category{
  }
  .back{
    font-weight: 500;
    font-size: 15px;
    line-height: 24px;
  }
  .current-category{
    color: #747A87;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    // padding-left: 10px;
  }

  .current-category {
  color: #747A87;
  font-weight: 400;
  font-size: 14px;
}

.item-name {
  width: 200px;
  white-space: normal;  // 允许文本换行
  word-break:keep-all;
  max-height: 32px;  // 如果需要限制最大高度，可以添加这个属性
  line-height: 14px;
  margin-bottom: 10px;
}

</style>
